import { CSSProperties } from 'react';

const inputStyle = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  } as CSSProperties,
  label: (isEnabled) => ({
    display: 'block',
    marginBottom: '8px',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '16px',
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  }),
};

export default inputStyle;
